import React, { FunctionComponent, useState, useRef } from 'react';
import { ICategoryModel } from '../../../models/category-model';
import plusIcon from '../../../assets/images/plus.svg';
import checkIcon from '../../../assets/images/check.svg';
import styles from './case-study-category.module.scss';
import { useOnClickOutside } from '../../../hooks/use-on-click-outside';
export interface ICaseStudyCategoryFilter {
  name: string;
  values: ICategoryModel[];
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    filter: string
  ) => void;
  clearAll: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    filters: string[]
  ) => void;
}

export const CaseStudyCategoryFilter: FunctionComponent<ICaseStudyCategoryFilter> = ({
  name,
  values,
  onChange,
  clearAll
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(wrapperRef, (): void => setIsOpen(false));

  const openHandler = (): void => setIsOpen(!isOpen);

  const onChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>,
    filter: string
  ): void => {
    onChange(event, filter);

    if (event.target.checked && filter) {
      return setSelectedFilters([...selectedFilters, filter]);
    }
    return setSelectedFilters([
      ...selectedFilters.filter(selectedFilter => selectedFilter !== filter)
    ]);
  };

  const clearAllHandler = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    clearAll(event, selectedFilters);

    setSelectedFilters([]);
  };

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <div className={styles.name} onClick={openHandler}>
        {name}
        {selectedFilters.length > 0 ? (
          <div className={styles.filtersNumber}>{selectedFilters.length}</div>
        ) : (
          <img className={styles.plusIcon} src={plusIcon} alt="plus" />
        )}
      </div>
      {isOpen && (
        <div className={styles.categoriesListWrapper}>
          <ul className={styles.categoriesList}>
            {values &&
              values.map((value: ICategoryModel, i: number) => (
                <li className={styles.categoryWrapper} key={i}>
                  <label className={styles.category}>
                    <input
                      className={styles.nativeInput}
                      type="checkbox"
                      onChange={(event): void =>
                        onChangeHandler(event, value.categoryUrl)
                      }
                      checked={selectedFilters.includes(value.categoryUrl)}
                    />
                    <div className={styles.valueWrapper}>
                      <span className={styles.value}>{value.categoryName}</span>
                      <img
                        className={styles.check}
                        src={checkIcon}
                        alt="check"
                      />
                    </div>
                  </label>
                </li>
              ))}
          </ul>
          <div className={styles.clear} onClick={clearAllHandler}>
            CLEAR ALL
          </div>
        </div>
      )}
    </div>
  );
};
